import { render, staticRenderFns } from "./GroupAdminInfo.vue?vue&type=template&id=5fd88826"
import script from "./GroupAdminInfo.vue?vue&type=script&lang=js"
export * from "./GroupAdminInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupAdminInfo.vue?vue&type=style&index=0&id=5fd88826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports